import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timeline" }
const _hoisted_2 = {
  class: "timeline-header",
  ref: "timelineHeader"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "timeline-inner" }

import { ref, computed, onMounted, onBeforeUnmount, useTemplateRef, defineAsyncComponent, markRaw } from 'vue';
import { useRoute } from 'vue-router';

import { t } from '@services/l10n';
import { routes } from '@services/router';

import Timeline from '@components/Timeline.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'SplitTimeline',
  setup(__props) {

const MapSplitMatter = defineAsyncComponent(() => import('@components/top-matter/MapSplitMatter.vue'));

const route = useRoute();

const containerRef = useTemplateRef<HTMLDivElement>('container');
const primaryRef = useTemplateRef<HTMLDivElement>('primary');
const timelineHeaderRef = useTemplateRef<HTMLDivElement>('timelineHeader');

const pointerDown = ref(false);
const primaryPos = ref(0);
const containerSize = ref(0);
const mobileOpen = ref(1);
const photoCount = ref(0);
let hammer: HammerManager | null = null;

const primary = computed(() => {
  switch (route.name) {
    case routes.Map.name:
      return markRaw(MapSplitMatter);
    default:
      return null;
  }
});

const headerClass = computed(() => {
  switch (mobileOpen.value) {
    case 0:
      return 'm-zero';
    case 1:
      return 'm-one';
    case 2:
      return 'm-two';
  }
});

onMounted(() => {
  void setupGestures();
});

onBeforeUnmount(() => {
  pointerUp();
  hammer?.destroy();
});

async function setupGestures() {
  const { default: Hammer } = await import('hammerjs');
  if (!timelineHeaderRef.value) return;

  hammer = new Hammer(timelineHeaderRef.value);
  hammer.get('swipe').set({
    direction: Hammer.DIRECTION_VERTICAL,
    threshold: 3,
  });
  hammer.on('swipeup', mobileSwipeUp);
  hammer.on('swipedown', mobileSwipeDown);
}

function isVertical() {
  return false; // for future
}

function sepDown(event: PointerEvent) {
  pointerDown.value = true;

  // Get position of primary element
  const rect = primaryRef.value!.getBoundingClientRect();
  primaryPos.value = isVertical() ? rect.top : rect.left;

  // Get size of container element
  const cRect = containerRef.value!.getBoundingClientRect();
  containerSize.value = isVertical() ? cRect.height : cRect.width;

  // Let touch handle itself
  if (event.pointerType === 'touch') return;

  // Otherwise, handle pointer events on document
  document.addEventListener('pointermove', documentPointerMove);
  document.addEventListener('pointerup', pointerUp);

  // Prevent text selection
  event.preventDefault();
  event.stopPropagation();
}

function sepTouchMove(event: TouchEvent) {
  if (!pointerDown.value) return;
  setFlexBasis(event.touches[0]);
}

function documentPointerMove(event: PointerEvent) {
  if (!pointerDown.value || !event.buttons) return pointerUp();
  setFlexBasis(event);
}

function pointerUp() {
  // Get rid of listeners on document quickly
  pointerDown.value = false;
  document.removeEventListener('pointermove', documentPointerMove);
  document.removeEventListener('pointerup', pointerUp);
}

function setFlexBasis(pos: { clientX: number; clientY: number }) {
  const ref = isVertical() ? pos.clientY : pos.clientX;
  const newSize = Math.max(ref - primaryPos.value, 50);
  const pctSize = (newSize / containerSize.value) * 100;
  primaryRef.value!.style.flexBasis = `${pctSize}%`;
}

function daysLoaded({ count }: { count: number }) {
  photoCount.value = count;
}

async function mobileSwipeUp() {
  mobileOpen.value = Math.min(mobileOpen.value + 1, 2);
}

async function mobileSwipeDown() {
  mobileOpen.value = Math.max(mobileOpen.value - 1, 0);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["split-container", headerClass.value]),
    ref: "container"
  }, [
    _createElementVNode("div", {
      class: "primary",
      ref_key: "primary",
      ref: primary
    }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(primary.value)))
    ], 512),
    _createElementVNode("div", {
      class: "separator",
      ref: "separator",
      onPointerdown: sepDown,
      onTouchmovePassive: sepTouchMove,
      onTouchendPassive: pointerUp,
      onTouchcancelPassive: pointerUp
    }, null, 544),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "swiper" }, null, -1)),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('memories', '{photoCount} photos', { photoCount: photoCount.value })), 1)
      ], 512),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(Timeline, { onDaysLoaded: daysLoaded })
      ])
    ])
  ], 2))
}
}

})